import { z } from 'zod';
import { partySchema } from '../../common';

/**
 * The executing-carrier slot on an Order.
 *
 * Phase 7 (relations-v2): flipped to a {@link partySchema} snapshot so
 * the executor carries the same `roles[]` / `ids[]` / `target` shape as
 * every other counterparty on the order (`user`, `client`, `contracts[i]
 * .buyer/seller`). That lets `TenantsBuilder.recompute` emit the carrier
 * tenants directly from this field, and lets viewers identify the
 * executor with a single party-shaped check (`target === 'org'`,
 * `roles` includes `carrier_company`/`broker`).
 *
 * Set by the allocation flow once a carrier has been picked up:
 * - **own-fleet path** — the creator's own Org becomes the executor.
 * - **targeted / private-network / public-network path** — the carrier
 *   accepting the {@link import('../offer').OfferSchema} becomes the
 *   executor.
 *
 * Stays `undefined` while the order is in `searching_for_driver` with
 * no accepted Offer yet.
 */
export const orderCarrierSchema = partySchema;

export type OrderCarrier = z.infer<typeof orderCarrierSchema>;
